export default {
  website: {
    shoutoutSliderText1:
      'Гледајте игри од Лига 1, Серија А, Бундеслига, Премиер лига, НФЛ, НБА, NCAA и многу повеќе!',
    'shoutout!': 'Пофали!',
    loveTheGame: 'САКАЈТЕ ЈА ИГРАТА. НАПРАВЕТЕ ЈА ВАША.',
    joinTheDedicated:
      'Придружете се на посветената спортска социјална мрежа - екосистем кој е посилен со спонзори и партнери.',
    aSportsCommunity: 'Збирно место на спортската заедница.',
    athletesMonetize: 'Спортистите заработуваат од својот бренд.',
    fansConnectDirectly: 'Навивачите директно се поврзуваат со спортистите.',
    ledByAthletes: 'ВОДЕНО ОД СПОРТИСТИ.',
    ledByFans: 'ВОДЕНО ОД НАВИВАЧИ.',
    ledBy: 'ВОДЕНО ОД',
    'athletes.': 'СПОРТИСТИ.',
    'fans.': 'НАВИВАЧИ.',
    goToApp: 'Одете на апликацијата',
    logout: 'Одјавете се',
    amAnAthlete: 'Јас сум спортист',
    monetizeYourBrand:
      'Заработете од вашиот бренд преку создавањето на уникатен свет со вашите обожаватели.',
    amAFan: 'Јас сум обожавател',
    connectDirectlyWith: 'Поврзете се со вашите омилени спортисти и други обожаватели.',
    athleteZone: 'СПОРТИСКА ЗОНА',
    fanZone: 'ФАН ЗОНА',
    ourAthletes: 'НАШИТЕ СПОРТИСТИ',
    news: 'Вести',
    ourStory: 'НАШАТА ПРИКАЗНА',
    sponsors: 'СПОНЗОРИ',
    contact: 'КОНТАКТ',
    athleteFocus: 'Фокус на спортистот',
    calculator: 'Калкулатор',
    seeHowMuch: 'Погледнете колку може да заработие од вашиот бренд.',
    weAllPlay: 'ПОДОБРО ИГРАМЕ ЗАЕДНО.',
    everybody: 'СИТЕ',
    playsBetter: 'ИГРААТ ПОДОБРО',
    weAll: 'НИЕ СИТЕ',
    playBetter: 'ИГРАМЕ ПОДОБРО',
    together: 'ЗАЕДНО.',
    video: 'Видео',
    tiffanyVan: 'Тифани Ван Соест',
    goto: 'Оди до',
    athleteZoneSmall: 'Спортска зона',
    latestNews: 'ПОСЛЕДНИ ВЕСТИ',
    ledByPartners: 'ВОДЕНО ОД ПАРТНЕРИ.',
    partnersAndSponsors: 'Партнери и спонзори',
    ledByTeams: 'ВОДЕНО ОД ТИМОВИ.',
    seeOurWork: 'Видете ја нашата работа со овие врвни спортисти',
    sportsCareer:
      'Спортските кариери може да бидат кратки, но вие сте стекнале животно искуство. Време е да ги уживаш во наградите.,',
    buildAnOngoing: 'Изградете постојан, одржлив приход.,',
    takeControl: 'Преземете ја контролата врз вашиот бренд - и вашата иднина.,',
    signUpForFree:
      'Пријавете се бесплатно и пресметајте колку може да заработувате од вашата кариера.,',
    'connect!': 'Поврзете се!',
    unlimitedAccess:
      'Неограничен пристап до вашите омилени спортисти. Изградете ја својата мрежа од спортски херои!',
    'stream!': 'Гледајте!',
    streamGamesFrom:
      'Гледајте игри од Лига 1, Серија А, Бундеслига, Премиер лига, НФЛ, НБА, NCAA и многу повеќе!',
    stayVisible: 'ОСТАНЕТЕ ВИДЛИВИ.',
    connectWithUs: 'Поврзете се со нас',
    newsletter: 'Билтен',
    typeEmail: 'Внесете е-пошта овде и притиснете Enter',
    typeAndEnter: 'Внесете е-пошта овде и притиснете Enter',
    wedLoveTo: 'Сакаме да го слушнеме вашето мислење.',
    sendUsAMessage: 'Испратете ни порака',
    notAnAthleteOrFan: 'Не сте спортист или обожавател?',
    connectWithUsHere: 'Во секој случај, поврзете се со нас овде!',
    home: 'Дома',
    fanZoneSmall: 'Фан зона',
    ourStorySmall: 'Нашата приказна',
    ourAthletesSmall: 'Нашите спортисти',
    selectCountry: 'Избери држава',
    signUp: 'Пријавете се',
    stopTheHate: 'Стоп за омразата',
    termsAndConditions: 'Правила и услови',
    privacyPolicy: 'Политика за приватност',
    playaz4playaz: '@playaz4playaz',
    allRigthsReserved: 'Сите права се задржани',
    led: 'ВОДЕНО',
    byTopAthletes: 'ОД ВРВНИ СПОРТИСТИ',
    partners: 'Партнери',
    investors: 'Инвеститори',
    attendees: 'Присутни',
    date: '26-29 април',
    location: 'Црква Весли, Флорида',
    dontMiss: 'НЕ ПРОПУШТАЈТЕ',
    outOn: 'ГО ',
    your: 'ВАШИОТ',
    timeToShine: 'МОМЕНТ ДА БЛЕСНЕТЕ.',
    registerForCombine: 'Регистрирајте се за Комбинирајте',
    registrationEnds: 'РЕГИСТРАЦИЈАТА ЗАВРШУВА',
    days: 'Денови',
    hours: 'Часови',
    minutes: 'Минути',
    seconds: 'Секунди',
    ourPartners: 'НАШИTE ПАРТНЕРИ.',
    enjoyTheseMembership: 'Уживајте во овие неверојатни предности на членството',
    sportUnites: 'СПОРТОТ ОБЕДИНУВА.',
    noDivide: 'НЕМА ПОДЕЛБИ.',
    videosArticles: 'Видеа, статии и интервјуа со спортски ѕвезди',
    instantMessaging: 'Инстант пораки со вашите омилени спортисти',
    discountOnEvent: 'Попусти на билети за настан и комерцијализирана стока',
    behindTheScenes: 'Пристап до затскриениот дел во светот на спортот. ',
    experienceSport: 'ИСКУСЕТЕ ГО СПОРТОТ КАКО ШТО ГО САКАТЕ.',
    theOnlySportsApp:
      'Единствената спортска апликација која ви овозможува директен контакт со вашите омилени спортисти - во реално време!',
    buildYourOwnWorld: 'Изградете го својот свет преку директно поврзување со спортистите.',
    chooseTheFeatures: 'Изберете ги карактеристиките што ги сакате.',
    interactWithAthletes: 'Комуницирајте со спортистите - и инспирирајте се!',
    sendAShoutout:
      'Испратете пофалба до вашиот спортист или тим веднаш пред или за време на натпреварот!',
    fanLife: '#FANLIFE',
    highlights: 'Истакнато',
    recentArticles: 'Последни статии',
    p4pxIra: 'p4p x Ајра Браун',
    uploadedDate: 'Поставено на 28 февруари 2022 година',
    youMightAlso: 'Можеби ќе ви се допадне и...',
    'subscribe!': 'Претплатете се!',
    getContent:
      'Добивајте содржина и пренос на вашиот омилен спорт - или сите други спортови на playaz4playaz!',
    'vipConnects!': 'VIP Поврзувања!',
    '1-to-1connections': 'Врски 1-на-1 со вашиот омилен спортист, виртуелно или лично!',
    watch: 'Гледајте: приказната p4p',
    caseStudies: 'Минати примери',
    aboutHenrySeals:
      'Дипломиран на Универзитетот Харвард, Хенри е искусен лидер. Во моментов, Хенри е CHRO за Zaiko, стартап со седиште во Јапонија, кој ги поддржува креаторите дигитално и хибридно да ги ангажираат своите обожаватели. Тој е исто така првиот јапонски комесар за човекови права роден во странство, како и основач на Фондацијата "Legacy" во Јапонија. Како CHRO за Paidy, тој ја претвори компанијата во една од единствените јапонски unicorns (компании вредни милијарди долари) и ја направи јавна трговска корпорација во 2021 година.\nТој исто така држеше високи позиции во тимот на човечки ресурси во Philip Morris International, AIG и NN. ',
    aboutHoustonRoss:
      'Хјустон има долгогодишно искуство со водење глобални организации и вршење подготовки за иднината, модернизирање на операции и инфраструктура и развој на тимови за работа на високо ниво. Неодамна, Хјустон беше CTO за Јапонија BNPL-unicorn Paidy, при што ја водеше организацијата кон успешен јавен излез.\nКако глобален лидер, Хјустон бил CTO и на глобални финансиски организации како што се AXA Life, ING и NN.\nКако спортски ентузијаст, тој има за цел да го искористи своето искуство во технологијата, финансиите и оперативната извонредност за да го направи P4P глобален лидер.',
    aboutJuliusGoldsmith:
      'Џулиус е адвокат со повеќе од 20 години искуство на Вол Стрит во делот за развој на бизнис, развој на нови производи и прекугранични трансакции. Џулиус има работено во Њујорк, Лондон, Сингапур и Токио каде што има долгогодишно искуство со работа во повеќе дисциплини, вклучувајќи развој на бизнисот, финансии, правни и даночни прашања. Џулиус е член на советниците на деканот на Колеџот за бизнис Силберман на Универзитетот Ферли Дикинсон (неговиот алма матер) и исто така има CPA.',
    aboutMarcelVanDruten:
      'Марсел Ван Друтен е искусен професионалец со докажано достигнување во глобалните технолошки средини. Роден и израснат во Амстердам, Холандија, до 21-годишна возраст Марсел активно играЛ фудбал како бестрашен бранител во највисоките аматерски лиги во различни фудбалски клубови.\nКористејќи ја својата експертиза со маркетинг и рекламнирање, Марсел им помога на светските брендови да развијат и имплементираат програми и иницијативи насочени кон зголемување на приходи и промовирање на брендот. Зборува повеќе јазици, вклучувајќи ги англиски, холандски и германски и има голема страст за боречки вештини, голф и формула 1. Марсел му помага на P4P да стане најдобрата спортска апликација во светот.',
    aboutMichaelAJacobs:
      'Мајкл е извршен директор и правник со разновидно досие од успеси во подобрување на операции преку супериорен ангажман во заедницата, човечки ресурси, работни односи и право. Во моментов, тој е виш лектор на Универзитетот во Њујорк, Факултетот за јавна служба Роберт Ф. Вагнер и помошен вонреден професор на Градскиот универзитет во Њујорк, Факултетот за професионални студии. Мајкл беше дополнителен член на факултетот на Глобалниот кампус на Универзитетот во Мериленд (порано, Универзитетскиот колеџ на Универзитетот во Мериленд) и Правниот факултет на Универзитетот Хауард.\n',
    aboutMichaelJackson:
      'Дипломиран на Универзитетот Колумбија, Мајкл е искусен производен менаџер и поранешен регионален шеф на испорака за глобални организации за управување со средства и богатство. Тој има долгогодишно искуство во испорака на глобални проекти насочени кон подобрување на оперативната ефикасност и испорака на услуги\/производи. \n\n',
    sponsorsSmall: 'Спонзори',
    becomeASponsor: 'СТАНЕТЕ СПОНЗОР НА P4P',
    content1: 'Лорем Ипсум...',
    content2: 'Лорем Ипсум...',
    ourTeams: 'НАШИТЕ ТИМОВИ.',
    paymentDetails: 'ДЕТАЛИ ЗА ПЛАЌАЊАТА',
    cancelWithin30Days:
      'Откажете во рок од 30 дена и нема да ви биде извршена наплата. Сè уште ќе можете да пристапите до основните функции.',
    cardNumber: 'БРОЈ НА КАРТИЧКА',
    expiry: 'ДАТА НА ИСТЕКУВАЊЕ',
    cvc: 'CVC',
    illDoItLater: 'Ќе го направам тоа подоцна',
    submit: 'Поднесете',
    athleteInformation: 'ИНФОРМАЦИИ ЗА СПОРТИСТИТЕ',
    contactInformation: 'КОНТАКТ ИНФОРМАЦИИ',
    otherInformation: 'ДРУГИ ИНФОРМАЦИИ',
    dateOfBirth: 'ДАТА НА РАЃАЊЕ',
    year: 'година',
    month: 'Месец',
    day: 'Ден',
    socialNetworks: 'СОЦИЈАЛНИТЕ МРЕЖИ',
    Instagram: 'Инстаграм',
    facebook: 'Фејсбук',
    twitter: 'Твитер',
    uploadHeadshot: 'Поставете удар со глава или кошаркарски акционен удар',
    phoneNumber: 'Телефонски број',
    sport: 'Спорт',
    linkInstagram: 'Линк до вашиот Инстаграм профил',
    linkFacebook: 'Линк до вашиот Фејсбук профил',
    linkTwitter: 'Линк до вашиот Твитер профил',
    athleteSignUp: 'Пријавување спортист',
    thankYou: 'ВИ БЛАГОДАРИМЕ',
    youWillBeSent: 'Наскоро ќе ви биде испратена потврда по е-пошта.',
    getTheApp: 'СИМНИ ЈА АПЛИКАЦИЈАТА!',
    or: 'ИЛИ',
    continueOnWebsite: 'Продолжете на веб-страницата',
    welcome: 'ДОБРЕДОЈДОВТЕ!',
    '30dayFull': '30-дневен целосен пристап!',
    enjoyTheseAmazing: 'Уживајте во овие неверојатни карактеристики бесплатно!',
    yesGiveMe: 'Да, дајте ми бесплатен пристап!',
    noThanksKeep: 'Не, благодарам, ќе останам на основното',
    letsWorkTogether:
      'Ајде да работиме заедно! Ве молиме пополнете ги вашите податоци и ќе стапиме во контакт со вас.',
    yourDetails: 'ВАШИТЕ ДЕТАЛИ',
    firstName: 'Име',
    lastName: 'Презиме',
    emailAddress: 'И-мејл адреса',
    companyInformation: 'ИНФОРМАЦИИ ЗА КОМПАНИЈАТА',
    companyName: 'Име на компанија',
    companyWebsite: 'Веб-страница на компанијата',
    login: 'Логирај Се',
    getApp: 'преземи ја апликацијата',
    letsTalk: 'Ајде да разговараме',
    sponsor: 'Спонзор',
    useTheApp: 'Користете ја апликацијата',
    messageSent: 'Пораката е успешно испратена.',
    invalidEmail: 'Неважечка е-пошта.',
    addedToNewsletter: 'Е-поштата е успешно додадена во билтенот.',
    recently: 'Неодамна'
  }
};
